const pRouter = [
  {
    path: "/",
    meta: { title: "首页" },
    redirect: "/home",
    hidden: true,
    component: () => import("@/views/Layout"),
    children: [
      {
        path: "/staffManage",
        name: "staffManage",
        meta: {
          title: "人员管理"
        },
        component: function () {
          return import("@/views/staff/staffManage");
        }
      },
      {
        path: "/staffAdd",
        name: "staffAdd",
        meta: {
          title: "新增人员"
        },
        component: function () {
          return import("@/views/staff/staffAdd");
        }
      },
      {
        path: "/staffEdit",
        name: "staffEdit",
        meta: {
          title: "编辑人员"
        },
        component: function () {
          return import("@/views/staff/staffAdd");
        }
      },
      {
        path: "/organizationStructure",
        name: "organizationStructure",
        meta: {
          title: "组织结构管理"
        },
        component: function () {
          return import("@/views/organizationStructure");
        }
      },
      {
        path: "/contractManage",
        name: "contractManage",
        meta: {
          title: "合同管理"
        },
        component: function () {
          return import("@/views/contract/contractManage");
        }
      },
      {
        path: "/addContract",
        name: "addContract",
        meta: {
          title: "新增合同"
        },
        component: function () {
          return import("@/views/contract/addContract");
        }
      },
      {
        path: "/editContract",
        name: "editContract",
        meta: {
          title: "编辑合同"
        },
        component: function () {
          return import("@/views/contract/addContract");
        }
      },
      {
        path: "/contractDetails",
        name: "contractDetails",
        meta: {
          title: "合同详情"
        },
        component: function () {
          return import("@/views/contract/contractDetails.vue");
        }
      },
      {
        path: "/contractTips",
        name: "contractTips",
        meta: {
          title: "合同说明"
        },
        component: function () {
          return import("@/views/contract/contractTips");
        }
      },
      {
        path: "/basicLibrary",
        name: "basicLibrary",
        meta: {
          title: "工作项基础库"
        },
        component: function () {
          return import("@/views/workItemBasicLibrary/basicLibrary");
        }
      },
      {
        path: "/areaLibrary",
        name: "areaLibrary",
        meta: {
          title: "区域基础库"
        },
        component: function () {
          return import("@/views/workItemBasicLibrary/areaLibrary");
        }
      },
      {
        path: "/libraryTarget",
        name: "libraryTarget",
        meta: {
          title: "新增工作项"
        },
        component: function () {
          return import("@/views/workItemBasicLibrary/libraryTarget");
        }
      },
      {
        path: "/projectExamine",
        name: "projectExamine",
        meta: {
          title: "项目审批"
        },
        component: function () {
          return import("@/views/projectExamine/projectExamine");
        }
      },

    ],
  },
];
export default pRouter;
